// import React from "react";

// const Progress = ({progress, status}) => {
//   const getColor = () => {
//     switch (status) {
//       case "encours":
//         return "text-cyan-500 bg-cyan-50 border border-cyan-500/10";
//       case "terminé":
//         return "text-indigo-500 bg-indigo-500 border border-indigo-500/10";
//       case "enretard":
//         return "text-red-500 bg-red-50 border border-red-500/20";
//       default:
//         return "text-violet-500 bg-violet-500 border border-violet-500/20";
//     }
//   };
//   return (
//     <div className="w-full bg-gray-200 rounded h-1.5">
//       <div
//         className={`${getColor()} rounded-full h-1.5 text-center text-xs font-medium `}
//         style={{ width: `${progress}%` }}
//       ></div>
//     </div>
//   );
// };

// export default Progress;

import React from "react";

const Progress = ({ progress, status }) => {
  const getColor = () => {
    switch (status) {
      case "encours": return "bg-cyan-500";
      case "terminé": return "bg-indigo-500";
      case "enretard": return "bg-red-500";
      default: return "bg-violet-500";
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-1">
        <span className="text-xs text-gray-500">Progression</span>
        <span className="text-sm font-bold text-gray-700">{progress}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`${getColor()} rounded-full h-2 transition-all duration-300`}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default Progress;
